module.exports = __webpack_public_path__ + "img/_weapon_spell_03.b84dd26c.png";